import { useState, useEffect } from 'react';
import { api } from '../services/api';

export default function Leaderboard({ userId }) {
  const [board, setBoard]           = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [inviteCode, setInviteCode] = useState('');
  const [joinCode, setJoinCode]     = useState('');
  const [tab, setTab]               = useState('global');

  useEffect(() => {
    api.leaderboard().then(r => setBoard(r.data));
    api.getUserChallenges(userId).then(r => setChallenges(r.data));
  }, [userId]);

  async function createChallenge() {
    const res = await api.createChallenge(userId);
    setInviteCode(res.data.inviteCode);
    setChallenges(c => [res.data, ...c]);
  }

  async function joinChallenge() {
    if (!joinCode.trim()) return;
    try {
      await api.joinChallenge(joinCode.trim(), userId);
      api.getUserChallenges(userId).then(r => setChallenges(r.data));
      setJoinCode('');
    } catch (e) {
      alert(e.response?.data?.error || 'Codice non valido');
    }
  }

  const rankStyle = i => i === 0 ? 'gold' : i === 1 ? 'silver' : i === 2 ? 'bronze' : '';
  const AVATAR_EMOJIS = ['🧟','😰','🥊','⚔️','🧘'];

  return (
    <div style={{ paddingTop: 8 }}>

      <div style={{ display: 'flex', margin: '0 12px 12px', gap: 8 }}>
        {[['global','🏆 Globale'], ['friends','⚔️ Sfide']].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} style={{
            flex: 1, padding: '10px', borderRadius: 10, border: 'none', cursor: 'pointer',
            background: tab === k ? 'var(--accent)' : 'var(--card)',
            color: tab === k ? '#fff' : 'var(--muted)',
            fontWeight: 700, fontSize: 13
          }}>{l}</button>
        ))}
      </div>

      {tab === 'global' && (
        <div className="card">
          <div className="card-title">classifica globale — top 20</div>
          {board.map((u, i) => (
            <div key={u.id} className={`lb-row ${u.id === userId ? 'lb-me' : ''}`}>
              <div className={`lb-rank ${rankStyle(i)}`}>
                {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1}
              </div>
              <div className="lb-nick">
                {u.nickname} {u.id === userId && '(tu)'}
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>
                  Lv.{u.level} · {AVATAR_EMOJIS[u.avatarTier]}
                  {u.streakDays > 0 && ` · 🔥${u.streakDays}d`}
                </div>
              </div>
              <div className="lb-xp">{u.xp} XP</div>
            </div>
          ))}
        </div>
      )}

      {tab === 'friends' && (
        <>
          <div className="card">
            <div className="card-title">crea sfida 7 giorni</div>
            <button className="btn btn-primary" onClick={createChallenge}>
              ⚔️ Crea sfida
            </button>
            {inviteCode && (
              <div style={{ marginTop: 12, padding: 14, background: 'var(--surface)', borderRadius: 10, textAlign: 'center' }}>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>Codice invito</div>
                <div style={{ fontSize: 28, fontWeight: 900, color: 'var(--accent)', letterSpacing: 4 }}>
                  {inviteCode}
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>Condividi con il tuo amico</div>
              </div>
            )}
          </div>

          <div className="card">
            <div className="card-title">accetta sfida</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input style={{
                flex: 1, padding: '10px 12px', background: 'var(--surface)',
                border: '1px solid var(--border)', borderRadius: 10,
                color: 'var(--text)', fontSize: 14, letterSpacing: 2
              }}
                value={joinCode}
                onChange={e => setJoinCode(e.target.value.toUpperCase())}
                placeholder="Codice" maxLength={6}
              />
              <button className="btn btn-secondary" style={{ width: 'auto', padding: '0 16px' }}
                      onClick={joinChallenge}>Entra</button>
            </div>
          </div>

          {challenges.length > 0 && (
            <div className="card">
              <div className="card-title">le tue sfide</div>
              {challenges.map(c => (
                <div key={c.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <div style={{ fontWeight: 700 }}>
                    Codice: <span style={{ color: 'var(--accent)' }}>{c.inviteCode}</span>
                  </div>
                  <div style={{ color: 'var(--muted)', marginTop: 2 }}>
                    Stato: <span style={{ color: c.status === 'ACTIVE' ? 'var(--green)' : 'var(--muted)' }}>
                      {c.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
